import React from 'react';

const ArmazemContext = React.createContext();

export default ArmazemContext;
